module.exports = __webpack_public_path__ + "static/media/focus-icon-1.558742d8.avif";